export { between } from './between/between';
export { clamp }   from './clamp/clamp';

export const { min, max, floor, ceil, abs, round } = Math;
